var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInformationCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 6.48584 17.5142 2 12 2C6.48584 2 2 6.48584 2 12C2 17.5142 6.48584 22 12 22C17.5142 22 22 17.5142 22 12ZM3 12C3 7.0376 7.0376 3 12 3C16.9624 3 21 7.0376 21 12C21 16.9624 16.9624 21 12 21C7.0376 21 3 16.9624 3 12ZM12 10C12.2457 10 12.4497 10.1767 12.492 10.4101L12.5 10.5V17.5C12.5 17.7764 12.2764 18 12 18C11.7543 18 11.5503 17.8233 11.508 17.5899L11.5 17.5V10.5C11.5 10.2236 11.7236 10 12 10ZM12.492 6.41007C12.4497 6.1767 12.2457 6 12 6C11.7236 6 11.5 6.22363 11.5 6.5V7.5L11.508 7.58993C11.5503 7.8233 11.7543 8 12 8C12.2764 8 12.5 7.77637 12.5 7.5V6.5L12.492 6.41007Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformationCircle);
export default __webpack_public_path__ + "static/media/icon-information-circle.c757abd21f884dc1a8992261622db712.svg";
export { ForwardRef as ReactComponent };